<template>
  <div class="product-center">
    <div class="produnct-center-content1">
      <!-- <component :is="HomeContent1"></component> -->
      <ProductCenterContent1/>
    </div>
  </div>
</template>

<script>
  import ProductCenterContent1 from '@/pages/product-center-contet/ProductCenterContent1.vue'
  export default {
    name: 'ProductCenter',
    components:{ProductCenterContent1}
  }
</script>

<style>
    .product-center{
        background-size: 100% 100%;
        background-image: url(../assets/img/cpzx-bj.jpg);
        background-repeat: no-repeat;
        padding: 1rem 1rem 0 1rem;
    }
    .produnct-center-content1{
        background: rgb(0,0,0,0.15);
        width: 100%;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/ProductCenter.vue